var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEyeOpen = function SvgEyeOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9 3C3 3 .75 9 .75 9S3 15 9 15s8.25-6 8.25-6S15 3 9 3m0 1.5c3.957 0 5.958 3.2 6.606 4.497C14.958 10.285 12.941 13.5 9 13.5c-3.957 0-5.958-3.2-6.606-4.497C3.043 7.715 5.059 4.5 9 4.5M9 6a3 3 0 1 0 0 6 3 3 0 0 0 0-6m0 1.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3"
  })));
};
export default SvgEyeOpen;